export class Slot {
    
    public id: string = "0";
    public name: string;   

    public event_id: string;   
    public event_name: string;   

    public slot_quantity: number;
    public slot_used: number;
    public slot_wait: number;
    public slot_wait_used: number;

    public topic_id: string;
    public topic_name: string;

    public categories:any[];

    constructor() {}
}